// Single source of truth for the project stage option list.
//
// `project.stage` stays a free-form string in the DB — no schema/migration is
// tied to this. This constant only drives the *selectable* options in Admin
// (the stage <select>) and the *filterable* pills in Portfolio, so those two
// lists can no longer drift apart. Existing projects keep whatever stage value
// they already have, even if it isn't in this list.
//
// Ordered from earliest to latest lifecycle stage.
export const PROJECT_STAGES = [
  'Concept',
  'Pre-Seed',
  'MVP',
  'Seed',
  'Series A',
  'Series B',
  'Launched',
  'Live',
  'Scaling',
  'Acquired',
  'Exited',
] as const;

// Union of the canonical stage strings. `project.stage` is intentionally typed
// as `string | ProjectStage` (see types.ts) so free-form values remain valid.
export type ProjectStage = (typeof PROJECT_STAGES)[number];
